module.exports = __webpack_public_path__ + "img/map2.6fd647fc.jpg";